import React from "react";
import { Redirect, Route } from "react-router-dom";
import { isAuthenticated } from "../services/authenticationService";
import { componentType } from "../types/customTypes";

const ProtectedRoute:React.FC<propTypes> = ({ component: Component, ...restOfProps }: propTypes) => {
    return (
      <Route
          {...restOfProps}
          render={(props) => (isAuthenticated() ? <Component {...{ ...restOfProps, ...props }} /> : <Redirect to="/login" />)}
        />
    );
}

type propTypes= {
  component: componentType,
  exact: boolean,
  path: string
};

export default ProtectedRoute;
